/**
 * @class SportGroupsListTypes
 * @memberof Mojito.Modules
 */
export default class SportGroupsListTypes {}

/**
 * Types of sport groups list.
 *
 * @readonly
 * @enum {string}
 * @memberof Mojito.Modules.SportGroupsListTypes
 */
SportGroupsListTypes.TYPE = {
    ALL: 'ALL',
    TOP: 'TOP',
};

SportGroupsListTypes.GROUP_ID = {
    TOP_LEAGUES: '-top-leagues',
    TOP_OUTRIGHTS: '-top-outrights',
};

/**
 * Types used for sorting of All Leagues.
 *
 * @readonly
 * @enum {string}
 * @memberof Mojito.Modules.SportGroupsListTypes
 */
SportGroupsListTypes.SORTING_TYPES = {
    BY_NAME: 'BY_NAME',
    BY_DISPLAY_ORDER: 'BY_DISPLAY_ORDER',
};
